import * as React from 'react';
import { IgcSnackbarComponent as Component } from 'igniteui-webcomponents';
import type { IgcSnackbarComponentEventMap } from 'igniteui-webcomponents';
import { type EventName, createComponent } from '../react-props.js';

/**
 * A snackbar component is used to provide feedback about an operation
 * by showing a brief message at the bottom of the screen.
 *
 * The component integrates with the
 * [Invoker Commands API](https://developer.mozilla.org/en-US/docs/Web/API/Invoker_Commands_API):
 * an Ignite button or a native `<button>` with `command="--show"` / `"--hide"` /
 * `"--toggle"` and `commandfor` pointing to this element will call the
 * corresponding method declaratively without any JavaScript.
 * @slot  - Default slot to render the snackbar content.
 * @slot action - Renders the action part of the snackbar. Usually an interactive element (button).
 * @fires igcAction - Emitted when the snackbar action button is clicked.
 * @csspart base - The base wrapper of the snackbar component.
 * @csspart message - The snackbar message.
 * @csspart action - The default snackbar action button.
 * @csspart action-container - The area holding the actions.
 * @class
 */
export const IgrSnackbar = /* @__PURE__ */ createComponent({
  tagName: 'igc-snackbar',
  displayName: 'IgrSnackbar',
  elementClass: Component,
  react: React,
  events: {
    onAction: 'igcAction' as EventName<
      IgcSnackbarComponentEventMap['igcAction']
    >,
  },
});

export type IgrSnackbar = Component;

/** @deprecated Module register is no longer needed and can be removed */
export const IgrSnackbarModule = Component;
